
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsab1da4d938bfa041c1cd12ad6cb2e18den from './en.yaml'
            i18n.addResourceBundle('en', 'ab1da4d938bfa041c1cd12ad6cb2e18d', flattenObject(nsab1da4d938bfa041c1cd12ad6cb2e18den), true, true);
        
        export default 'ab1da4d938bfa041c1cd12ad6cb2e18d';
    